import React, { useState, useEffect, useRef, useContext } from 'react';
import { useSpring, animated } from 'react-spring';
import { Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './../BottomSheet.css';
import { useDrag } from 'react-use-gesture';
import { WebSocketContext } from "../WebSocketContext";
import { useTheme } from '../contexts/ThemeContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomToast from './CustomToast';
import { blue } from '@mui/material/colors';
import { mediatorAppFetch } from '../utils/apiFetch';
import { playTradeSound } from '../utils/tradeSound';
import ScriptIcon from './ScriptIcon';

const BottomSheetPortfolio = ({ userDetails, position, isOpen, onClose }) => {
  const { refreshTradesAndPortfolio, submitRejectionLog } = useContext(WebSocketContext);
  const { isDarkMode } = useTheme();
  const [disableBtn, setDisable] = useState(false);
  const styles = useSpring({
    transform: isOpen ? 'translateY(0%)' : 'translateY(100%)',
  });

  // console.log("BottomSheetPortfolio",stock);

  const showToast = (type, message) => {
    if(type==1){
      toast.success(<CustomToast title={"Trade Placed"} description={message} />, {
          position:'top-right',
          autoClose: 7000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
    }
    else if(type==2){
      toast.success(<CustomToast title={"Order Placed"} description={message} />, {
          position:'top-right',
          autoClose: 7000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
    }
    else if(type==3){
      toast.error(<CustomToast title={"Order Failed"} description={message} />, {
          position:'top-right',
          autoClose: 7000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
    }
};

  const [{ y }, api] = useSpring(() => ({ y: 0 }));

  const [successAlert, setSuccessAlert] = useState({ show: false, title: '', message: '' });

  const successAlertSpring = useSpring({
    opacity: successAlert.show ? 1 : 0,
    scale: successAlert.show ? 1 : 0.85,
    config: { tension: 300, friction: 25 }
  });

  const handleSuccessAlertClose = () => {
    setSuccessAlert({ show: false, title: '', message: '' });
    onClose();
  };

  React.useEffect(() => {
    api.start({ y: isOpen ? 0 : 100 });
  }, [isOpen, api]);

  const [isDepthExpanded, setIsDepthExpanded] = useState(true);
  const [lots, setLots] = useState(position.orderLotQuantity);
  const [quantity, setQuantity] = useState(position.lotsize);
  const [orderExecutionType, setOrderExecutionType] = useState('Market');
  const [isLimitOrder, setIsLimitOrder] = useState(false);
  const [price, setPrice] = useState('');

  const toggleDepth = () => {
    setIsDepthExpanded(!isDepthExpanded);
  };

  const prevLotsRef = useRef(lots);
  const prevQuantityRef = useRef(quantity);

  // useEffect(() => {
  //   if (isOpen) {
  //     // Initialize values based on the stock's lot size when the bottom sheet opens
  //     const initialLotSize = position.lotsize || 1;
  //     setQuantity(initialLotSize);
  //     setLots(1);
  //     prevLotsRef.current = 1;
  //     prevQuantityRef.current = initialLotSize;
  //   }
  // }, [isOpen, position.lotsize]);

  
  const handleOrderTypeToggle = (orderExecutionType) => {
    setOrderExecutionType(orderExecutionType);
    //alert("Limit Order: "+!isLimitOrder)
  };

  const buyDepth = position.live.depth?.buy || [];
  const sellDepth = position.live.depth?.sell || [];

  // Calculate the change percentage
  const _Bid = position.buyPrice = position.live.Bid!=undefined ? position.live.Bid : position.buyPrice;
  const _Ask = position.sellPrice = position.live.Ask!=undefined ? position.live.Ask : position.sellPrice;
  const _Open = position.live.Open!=undefined ? position.live.Open : position.open;
  const _High = position.live.High!=undefined ? position.live.High : position.high;
  const _Low = position.live.Low!=undefined ? position.live.Low : position.low;
  const _Prev_Close = position.live.Prev_Close!=undefined ? position.live.Prev_Close : position.close;
  const _LTP = position.live.LTP!=undefined ? position.live.LTP : position.lastTradedPrice;

  const Change_per = ((_LTP - _Prev_Close) / _Prev_Close * 100).toFixed(2);
  const Change = (_LTP - _Prev_Close).toFixed(2);

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('backdrop')) {
      onClose();
    }
  };

  const createOrder = async (orderType) => {
    playTradeSound(orderType === 1 ? 'buy' : 'sell');
    setDisable(true);
    if (quantity < 1) {
      alert("Quantity should be at least 1.");
      setDisable(false);

      var data = JSON.stringify({
          clientId: userDetails.clientId,
          parent_id: userDetails.parentId,
          stockId: position.stockId,
          stockExpiry: '"'+position.expiry+'"',
          stockName: '"'+position.stockName+'"',
          orderTransactionType: 2,
          orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
          buy_sell: orderType,
          lot: position.orderLotQuantity,
          quantity: position.orderQuantity,
        remark: '"Quantity should be at least 1."',
        orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
      });

      submitRejectionLog(data);

      return;
    }

    // const nowTime = new Date();
    // const lastTradeTimeUnix = new Date(stock.lastTradeTime * 1000);
    // const timeDiffInSecond = Math.ceil((nowTime - lastTradeTimeUnix) / 1000);

    // if (position.autoCutDate <= new Date().toISOString().split('T')[0]) {
    //   //alert("Can't trade after autocut date.");
    //   return;
    // }

    let orderAmount = 0;

    if (_Bid <= 0 || _Ask <= 0 || _Bid == _Ask) 
    {
      alert("Price not updated, please refresh");
      setDisable(false);

      var data = JSON.stringify({
          clientId: userDetails.clientId,
          parent_id: userDetails.parentId,
          stockId: position.stockId,
          stockExpiry: '"'+position.expiry+'"',
          stockName: '"'+position.stockName+'"',
          orderTransactionType: 2,
          orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
          buy_sell: orderType,
          lot: position.orderLotQuantity,
          quantity: position.orderQuantity,
        remark: '"Price not updated, please refresh."',
        orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
      });

      submitRejectionLog(data);

      return;
    }

    if(orderExecutionType=="Limit" || orderExecutionType=="SL"){
      if(Number(price) < Number(position.lower_circuit) || Number(price) > Number(position.upper_circuit)) {
        alert("Order price is beyond daily price range.");
        setDisable(false);

        var data = JSON.stringify({
          clientId: userDetails.clientId,
          parent_id: userDetails.parentId,
          stockId: position.stockId,
          stockExpiry: '"'+position.expiry+'"',
          stockName: '"'+position.stockName+'"',
          orderTransactionType: 2,
          orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
          buy_sell: orderType,
          lot: position.orderLotQuantity,
          quantity: position.orderQuantity,
          remark: '"Order price is beyond daily price range."',
          orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
        });
  
        submitRejectionLog(data);

        return;
      }
    }

    if (orderExecutionType=="Limit") 
    {
      if(price == _LTP){
          alert("Order price should not be equal to LTP.");
          setDisable(false);

          var data = JSON.stringify({
            clientId: userDetails.clientId,
            parent_id: userDetails.parentId,
            stockId: position.stockId,
            stockExpiry: '"'+position.expiry+'"',
            stockName: '"'+position.stockName+'"',
            orderTransactionType: 2,
            orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
            buy_sell: orderType,
            lot: position.orderLotQuantity,
            quantity: position.orderQuantity,
            remark: '"Order price should not be equal to LTP."',
            orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
          });
    
          submitRejectionLog(data);

          return;
      }

      if (orderType === 1) {
        if (price >= _Bid) {
          alert("Order price must be less than bid price.");
          setDisable(false);

          var data = JSON.stringify({
            clientId: userDetails.clientId,
            parent_id: userDetails.parentId,
            stockId: position.stockId,
            stockExpiry: '"'+position.expiry+'"',
            stockName: '"'+position.stockName+'"',
            orderTransactionType: 2,
            orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
            buy_sell: orderType,
            lot: position.orderLotQuantity,
            quantity: position.orderQuantity,
            remark: '"Order price must be less than bid price."',
            orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
          });
    
          submitRejectionLog(data);

          return;
        }
      } else {
        if (price <= _Ask) {
          alert("Order price must be greater than ask price.");
          setDisable(false);

          var data = JSON.stringify({
            clientId: userDetails.clientId,
            parent_id: userDetails.parentId,
            stockId: position.stockId,
            stockExpiry: '"'+position.expiry+'"',
            stockName: '"'+position.stockName+'"',
            orderTransactionType: 2,
            orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
            buy_sell: orderType,
            lot: position.orderLotQuantity,
            quantity: position.orderQuantity,
            remark: '"Order price must be greater than ask price."',
            orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
          });
    
          submitRejectionLog(data);

          return;
        }
      }
    }
    else if (orderExecutionType=="SL") 
    { 
        if(price == _LTP){
            alert("Order price should not be equal to LTP.");
            setDisable(false);

            var data = JSON.stringify({
              clientId: userDetails.clientId,
              parent_id: userDetails.parentId,
              stockId: position.stockId,
              stockExpiry: '"'+position.expiry+'"',
              stockName: '"'+position.stockName+'"',
              orderTransactionType: 2,
              orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
              buy_sell: orderType,
              lot: position.orderLotQuantity,
              quantity: position.orderQuantity,
              remark: '"Order price should not be equal to LTP."',
              orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
            });
      
            submitRejectionLog(data);

            return;
        }

        if(orderType==2){
          if(price >= _Bid){
            alert("Order price should be less than bid price."); 
            setDisable(false);

            var data = JSON.stringify({
              clientId: userDetails.clientId,
              parent_id: userDetails.parentId,
              stockId: position.stockId,
              stockExpiry: '"'+position.expiry+'"',
              stockName: '"'+position.stockName+'"',
              orderTransactionType: 2,
              orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
              buy_sell: orderType,
              lot: position.orderLotQuantity,
              quantity: position.orderQuantity,
              remark: '"Order price should be less than bid price."',
              orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
            });
      
            submitRejectionLog(data);

            return;
          }
        }
        else {
          if(price <= _Ask){
            alert("Order price should be greater than ask price."); 
            setDisable(false);

            var data = JSON.stringify({
              clientId: userDetails.clientId,
              parent_id: userDetails.parentId,
              stockId: position.stockId,
              stockExpiry: '"'+position.expiry+'"',
              stockName: '"'+position.stockName+'"',
              orderTransactionType: 2,
              orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
              buy_sell: orderType,
              lot: position.orderLotQuantity,
              quantity: position.orderQuantity,
              remark: '"Order price should be greater than ask price."',
              orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
            });
      
            submitRejectionLog(data);

            return;
          }
        }
    }

    if (orderType === 2) 
    {
        orderAmount = quantity * _Bid;
    } 
    else if (orderType === 1) {
        orderAmount = quantity * _Ask;
    }

    if (lots <= 0) {
      alert("Problem with lot quantity.");
      setDisable(false);

      var data = JSON.stringify({
        clientId: userDetails.clientId,
        parent_id: userDetails.parentId,
        stockId: position.stockId,
        stockExpiry: '"'+position.expiry+'"',
        stockName: '"'+position.stockName+'"',
        orderTransactionType: 2,
        orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
        buy_sell: orderType,
        lot: position.orderLotQuantity,
        quantity: position.orderQuantity,
        remark: '"Problem with lot quantity."',
        orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
      });

      submitRejectionLog(data);

      return;
    }

    position.dispName = position.dispname;

    position.stock = position.stock || {};

    position.stock.instrumentIdentifier = position.stockId;
    position.stock.exchange = position.exchange;
    position.stock.dispName = position.stockName;
    position.stock.lotVariant = String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA';

    try {
      const response = await mediatorAppFetch({
        method: 'POST',
        body: JSON.stringify({
          stock: position,
					orderTypeBuySell: orderType,
					orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
					lots: position.orderLotQuantity,
					lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA',
					orderTransactionType: 2,
					orderDevice: 1,
					limitSlPrice: price,
					ip: process.env.REACT_APP_USER_IP,
        }),
      });
      const data = await response.json();

      if (!data.success) 
      {
          var msg = data.message;

          setDisable(false);

          if(data.message=="SL Position"){
            msg = "Please remove SL from trades.";
          }
          else if(data.message=="Position already closed."){
            msg = "Position already closed.";
          } else {
            msg = data.message;
          }

          showToast(3, msg, "Order Failed");

          var dataa = JSON.stringify({
            clientId: userDetails.clientId,
            parent_id: userDetails.parentId,
            stockId: position.stockId,
            stockExpiry: '"'+position.expiry+'"',
            stockName: '"'+position.stockName+'"',
            orderTransactionType: 2,
            orderExecutionType: orderExecutionType=="Market" ? 1 : (orderExecutionType=="Limit" ? 2 : 3),
            buy_sell: orderType,
            lot: position.orderLotQuantity,
            quantity: position.orderQuantity,
            remark: '"'+msg+'"',
            orderPrice: (orderExecutionType=="Limit" || orderExecutionType=="SL") ? price : (orderType==1 ? position.sellPrice : position.buyPrice),
        lotVariant: String(position.lotVariant || '').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA'
          });
    
          submitRejectionLog(dataa);

      } 
      else {
        setDisable(false);

        var b_s = orderType == 1 ? 'Buy' : 'Sell';
        var msg = b_s + " " + Number(position.orderLotQuantity).toFixed(2) + " Lot(s) of " + position.stockName + " @" + Number(data.orderPrice).toFixed(2);

        refreshTradesAndPortfolio('both');

        var title = (orderExecutionType === 'Limit' || orderExecutionType === 'SL')
          ? orderExecutionType + " Order Successful"
          : "Order Successful";
        setSuccessAlert({ show: true, title, message: msg });
        
      }
    } catch (error) {
      console.error("Error:", error);
      
      setDisable(false);
    }
  };

  const formatMoney = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return '—';
    return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const formatPrice = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return '—';
    return num.toFixed(2);
  };

  const changeUp = Number(Change) > 0;
  const isBuyPosition = position.buy_sell == 1;
  const exchangeLabel =
    position.exchange === 'FUTCOM' ? 'MCX' :
    position.exchange === 'FUTSTK' ? 'NSE FUT' :
    position.exchange === 'OPTSTK' ? 'NSE OPT' :
    position.exchange;
  const showSl = String(userDetails.clientId) !== '726867';
  const actionPrice = orderExecutionType !== 'Market' && price
    ? formatPrice(price)
    : formatPrice(isBuyPosition ? _Bid : _Ask);

  return (
    <>
      <ToastContainer />
      {successAlert.show && (
        <animated.div
          className={`success-alert-overlay ${isDarkMode ? 'dark-theme' : 'light-theme'}`}
          style={{ opacity: successAlertSpring.opacity }}
          data-theme={isDarkMode ? 'dark' : 'light'}
          onClick={e => e.stopPropagation()}
        >
          <animated.div
            className="success-alert-box"
            style={{
              transform: successAlertSpring.scale.to(s => `scale(${s})`),
              opacity: successAlertSpring.opacity
            }}
            onClick={e => e.stopPropagation()}
          >
            <div className="success-alert-icon-wrap">
              <CheckCircleIcon className="success-alert-icon" />
            </div>
            <Typography variant="h6" className="success-alert-title">{successAlert.title}</Typography>
            <Typography className="success-alert-message">{successAlert.message}</Typography>
            <Button
              variant="contained"
              className="success-alert-btn"
              onClick={handleSuccessAlertClose}
              fullWidth
            >
              OK
            </Button>
          </animated.div>
        </animated.div>
      )}
      {isOpen && <div className="backdrop" onClick={handleBackdropClick} />}
      {isOpen && (
        <animated.div
          style={styles}
          className={`trade-sheet ${isDarkMode ? 'dark-theme' : 'light-theme'}`}
          data-theme={isDarkMode ? 'dark' : 'light'}
        >
          <div className="trade-sheet-handle" />

          <div className="trade-sheet-head">
            <div className="trade-sheet-script">
              <ScriptIcon name={position.stockName || position.dispname} size={36} />
              <div className="trade-sheet-identity">
                <div className="trade-sheet-name">
                  {String(position.stockName || '').replace(/ MINI$/i, '')}
                  {String(position.lotVariant || '').toUpperCase() === 'MINI' && (
                    <span className="lot-variant-mini">MINI</span>
                  )}
                </div>
                <div className="trade-sheet-meta">
                  <span className="trade-sheet-exch">{exchangeLabel}</span>
                  {position.expiry && <span>{position.expiry}</span>}
                  <span>QTY {position.orderQuantity}</span>
                </div>
              </div>
            </div>
            <div className="trade-sheet-ltp">
              <strong>₹{formatPrice(_LTP)}</strong>
              <span className={changeUp ? 'up' : 'down'}>
                {changeUp ? '+' : ''}{formatPrice(Change)} ({changeUp ? '+' : ''}{Change_per}%)
              </span>
            </div>
            <button type="button" className="trade-sheet-close" onClick={onClose} aria-label="Close">
              <CloseIcon />
            </button>
          </div>

          <div className="trade-quote-panel">
            <div className="trade-quote-row">
              <div className="trade-quote bid">
                <span>Bid</span>
                <strong>{formatPrice(_Bid)}</strong>
              </div>
              <div className="trade-quote ask">
                <span>Ask</span>
                <strong>{formatPrice(_Ask)}</strong>
              </div>
            </div>
            <div className="trade-ohlc">
              {[
                ['Open', _Open],
                ['High', _High],
                ['Low', _Low],
                ['Close', _Prev_Close]
              ].map(([label, value]) => (
                <div key={label}>
                  <span>{label}</span>
                  <strong>{formatPrice(value)}</strong>
                </div>
              ))}
            </div>
            {position.exchange !== 'OPTSTK' && (
              <div className="trade-range">
                Day range {position.lower_circuit} – {position.upper_circuit}
              </div>
            )}
          </div>

          {buyDepth.length > 0 && (
            <div className="trade-depth">
              <button type="button" className="trade-depth-toggle" onClick={toggleDepth}>
                <span>Market Depth</span>
                {isDepthExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </button>
              {isDepthExpanded && (
                <div className="trade-depth-book">
                  <div>
                    <div className="trade-depth-col-head bid">
                      <span>Qty</span>
                      <span>Bid</span>
                    </div>
                    {buyDepth.map((row, index) => (
                      <div key={`b-${index}`} className="trade-depth-row">
                        <span>{row.quantity}</span>
                        <span className="bid">{formatPrice(row.price)}</span>
                      </div>
                    ))}
                  </div>
                  <div>
                    <div className="trade-depth-col-head ask">
                      <span>Ask</span>
                      <span>Qty</span>
                    </div>
                    {sellDepth.map((row, index) => (
                      <div key={`s-${index}`} className="trade-depth-row">
                        <span className="ask">{formatPrice(row.price)}</span>
                        <span>{row.quantity}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="trade-controls">
            {position.exchange !== 'OPTSTK' && (
              <div className="trade-type-row">
                <div className="trade-seg">
                  <button type="button" className={orderExecutionType === 'Market' ? 'active' : ''} onClick={() => handleOrderTypeToggle('Market')}>Market</button>
                  <button type="button" className={orderExecutionType === 'Limit' ? 'active' : ''} onClick={() => handleOrderTypeToggle('Limit')}>Limit</button>
                  {showSl && (
                    <button type="button" className={orderExecutionType === 'SL' ? 'active' : ''} onClick={() => handleOrderTypeToggle('SL')}>SL</button>
                  )}
                </div>
                {orderExecutionType !== 'Market' && (
                  <input
                    type="number"
                    inputMode="decimal"
                    value={price}
                    placeholder={orderExecutionType === 'SL' ? 'SL price' : 'Limit price'}
                    className="trade-limit-input"
                    onChange={(e) => setPrice(e.target.value)}
                  />
                )}
              </div>
            )}
            <div className="trade-qty">
              <div className="trade-steppers">
                <div className="trade-stepper">
                  <label>Lots</label>
                  <div>
                    <input value={Number(lots).toFixed(2)} disabled readOnly />
                  </div>
                </div>
                <div className="trade-stepper">
                  <label>Quantity</label>
                  <div>
                    <input value={Number(quantity)} disabled readOnly />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="trade-sheet-footer">
            <div className="trade-funds">
              <div className="trade-funds-bal">
                <span>Balance</span>
                <strong>₹{formatMoney(userDetails.availableMargin)}</strong>
              </div>
            </div>
            <div className="trade-actions buy-only">
              {isBuyPosition ? (
                <button
                  type="button"
                  className="trade-btn sell"
                  disabled={disableBtn}
                  onClick={() => createOrder(2)}
                >
                  <span>SELL</span>
                  <small>@ {actionPrice}</small>
                </button>
              ) : (
                <button
                  type="button"
                  className="trade-btn buy"
                  disabled={disableBtn}
                  onClick={() => createOrder(1)}
                >
                  <span>BUY</span>
                  <small>@ {actionPrice}</small>
                </button>
              )}
            </div>
          </div>
        </animated.div>
      )}
    </>
  );
};

export default BottomSheetPortfolio;
